import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ArrowRight } from 'lucide-react';
import { useLang } from '@/contexts/LanguageContext';

/**
 * WOMIO — Social Projects dashboard banner (Phase 24).
 * Always visible in the consumer Dashboard, regardless of whether there are
 * active projects. Clicking it navigates to the internal /social-projects page.
 */
export default function SocialProjectsBanner() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div
      data-testid="social-projects-banner"
      className="relative overflow-hidden rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/5 via-accent/5 to-background p-6 sm:p-8 cursor-pointer group hover:shadow-lg transition-shadow"
      onClick={() => navigate('/social-projects')}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate('/social-projects'); }}
    >
      <div className="flex items-start gap-4 sm:gap-6">
        <div className="shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-primary/10 flex items-center justify-center">
          <Heart className="w-6 h-6 sm:w-7 sm:h-7 text-primary" strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg sm:text-xl font-serif font-bold text-primary mb-1.5" data-testid="banner-title">
            {t('sp_banner_title')}
          </h3>
          <p className="text-sm text-muted-foreground font-sans mb-3 sm:mb-4" data-testid="banner-desc">
            {t('sp_banner_desc')}
          </p>
          <div className="inline-flex items-center gap-2 text-sm font-sans font-semibold text-primary group-hover:gap-3 transition-all" data-testid="banner-cta">
            {t('sp_banner_cta')}
            <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </div>
        </div>
      </div>
    </div>
  );
}
